export const RecruitAdminDatas = [
  {
    userName: "Aisha Suleiman",
    contactNo: "7012345678",
    baseAddress: "Force Headquarters, Shehu Shagari Way, Central Business District, Abuja, FCT",
    state: "Benue",
    city: "Makurdi",
    addedOn: 1729785840000,
    status: "Active",
    email:"aisha.suleiman@example.com"
  },
  {
    userName: "Samuel Ojo",
    contactNo: "802 345 6789",
    baseAddress: "1 Kam Salem House, Moloney Street, Onikan, Lagos State",
    state: "Plateau",
    city: "Jos",
    addedOn: 1729630200000,
    status: "In Active",
    email:"samuel.ojo@example.com"
  },
  {
    userName: "Kemi Adebayo",
    contactNo: "813 456 7890",
    baseAddress: "1 Federal Secretariat Road, Benin City, Edo State",
    state: "Abia",
    city: "Umuahia",
    addedOn: 1729540500000,
    status: "Active",
    email:"kemi.adebayo@example.com"
  },
  {
    userName: "Ngozi Nwankwo",
    contactNo: "904 567 8901",
    baseAddress: "3 Diamond Hill Road, Calabar, Cross River State",
    state: "Enugu",
    city: "Nsukka",
    addedOn: 1729454400000,
    status: "Pending",
    email: "tunde.ayodele@example.com",
  },
  {
    userName: "Ibrahim Musa",
    contactNo: "705 678 9012",
    baseAddress: "1 CID Road, Panti, Yaba, Lagos State",
    state: "Enugu",
    city: "Enugu",
    addedOn: 1729272000000,
    status: "Active",
    email: "samuel.ojo@example.com",
  },
  {
    userName: "Amaka Eze",
    contactNo: "806 789 0123",
    baseAddress: "Mobolaji Bank Anthony Way, Ikeja, Lagos State",
    state: "Edo",
    city: "Benin",
    addedOn: 1729171500000,
    status: "In Active",
    email: "chukwuemeka.okoye@example.com",
  },
  {
    userName: "Chinedu Okafor",
    contactNo: "817 890 1234",
    baseAddress: "Ibrahim Taiwo Road, Wuse Zone 2, Abuja, FCT",
    state: "Delta",
    city: "Warri",
    addedOn: 1729073400000,
    status: "Active",
    email: "femi.adeyemi@example.com",
  },
  {
    userName: "Fatima Abdullahi",
    contactNo: "701 567 8902",
    baseAddress: "Government House Road, Minna, Niger State",
    state: "Niger",
    city: "Minna",
    addedOn: 1728987000000,
    status: "Pending",
    email: "nkechi.nwosu@example.com",
  },
  {
    userName: "Tunde Bakare",
    contactNo: "809 234 5678",
    baseAddress: "7 Independence Way, Kaduna South, Kaduna State",
    state: "Kaduna",
    city: "Kaduna",
    addedOn: 1728900600000,
    status: "In Active",
    email: "aisha.suleiman@example.com",
  },
  {
    userName: "Musa Adamu",
    contactNo: "706 789 0123",
    baseAddress: "22 Aliyu Crescent, Maiduguri, Borno State",
    state: "Borno",
    city: "Maiduguri",
    addedOn: 1728814200000,
    status: "Active",
    email: "samuel.ojo@example.com",
  },
  {
    userName: "Grace Okon",
    contactNo: "803 456 7890",
    baseAddress: "14 Mission Road, Uyo, Akwa Ibom State",
    state: "Akwa Ibom",
    city: "Uyo",
    addedOn: 1728727800000,
    status: "Active",
    email: "kemi.adebayo@example.com",
  },
  {
    userName: "Bola Yusuf",
    contactNo: "905 678 9012",
    baseAddress: "4 Marina Street, Lagos Island, Lagos State",
    state: "Lagos",
    city: "Lagos",
    addedOn: 1728641400000,
    status: "In Active",
    email: "ikenna.nwachukwu@email.com",
  }
]

export const FieldAgentSupervisorDatas = [
  {
    userName: "John Okoro",
    email: "john.okoro@example.com",
    contactNo: "707 765 4321",
    baseAddress: "45 Ojo Road, Port Harcourt, Rivers State",
    state: "Rivers",
    city: "Port Harcourt",
    addedOn: 1730464800000,
    status: "Active"
  },
  {
    userName: "Grace Adeyemi",
    email: "grace.adeyemi@example.com",
    contactNo: "706 543 2109",
    baseAddress: "34 Ibadan Street, Ibadan, Oyo State",
    state: "Oyo",
    city: "Ibadan",
    addedOn: 1730379900000,
    status: "In Active"
  },
  {
    userName: "Emmanuel Olayemi",
    email: "emmanuel.olayemi@example.com",
    contactNo: "705 234 6789",
    baseAddress: "89 Adeniyi Jones Avenue, Lagos",
    state: "Lagos",
    city: "Lagos",
    addedOn: 1730292600000,
    status: "Active"
  },
  {
    userName: "Fatimah Bello",
    email: "fatimah.bello@example.com",
    contactNo: "704 321 9876",
    baseAddress: "12 Zaria Road, Kaduna, Kaduna State",
    state: "Kaduna",
    city: "Kaduna",
    addedOn: 1730205900000,
    status: "Pending"
  },
  {
    userName: "Ibrahim Musa",
    email: "ibrahim.musa@example.com",
    contactNo: "703 567 1234",
    baseAddress: "78 Bompai Road, Kano City, Kano",
    state: "Kano",
    city: "Kano",
    addedOn: 1730118000000,
    status: "Active"
  },
  {
    userName: "Ngozi Nwankwo",
    email: "ngozi.nwankwo@example.com",
    contactNo: "702 876 5432",
    baseAddress: "No. 56 Umuahia Road, Abia State",
    state: "Abia",
    city: "Aba",
    addedOn: 1730034900000,
    status: "In Active"
  },
  {
    userName: "Chinedu Okafor",
    email: "chinedu.okafor@example.com",
    contactNo: "701 987 6543",
    baseAddress: "123 Ogui Road, Enugu, Enugu State",
    state: "Enugu",
    city: "Enugu",
    addedOn: 1729952100000,
    status: "Active"
  },
  {
    userName: "Aisha Suleiman",
    email: "aisha.suleiman@example.com",
    contactNo: "701 234 5678",
    baseAddress: "Force Headquarters, Shehu Shagari Way, Abuja, FCT",
    state: "Benue",
    city: "Makurdi",
    addedOn: 1729785840000,
    status: "Active"
  },
  {
    userName: "Samuel Ojo",
    email: "samuel.ojo@example.com",
    contactNo: "802 345 6789",
    baseAddress: "1 Kam Salem House, Moloney Street, Lagos State",
    state: "Plateau",
    city: "Jos",
    addedOn: 1729630200000,
    status: "In Active"
  },
  {
    userName: "Kemi Adebayo",
    email: "kemi.adebayo@example.com",
    contactNo: "813 456 7890",
    baseAddress: "1 Federal Secretariat Road, Benin City, Edo State",
    state: "Abia",
    city: "Umuahia",
    addedOn: 1729540500000,
    status: "Active"
  },
  {
    userName: "Fatima Abdullahi",
    email: "fatima.abdullahi@example.com",
    contactNo: "701 567 8902",
    baseAddress: "Government House Road, Minna, Niger State",
    state: "Niger",
    city: "Minna",
    addedOn: 1728987000000,
    status: "Pending"
  },
  {
    userName: "Bola Yusuf",
    email: "bola.yusuf@example.com",
    contactNo: "905 678 9012",
    baseAddress: "4 Marina Street, Lagos Island, Lagos State",
    state: "Lagos",
    city: "Lagos",
    addedOn: 1728641400000,
    status: "In Active"
  }
]

export const FieldAgentDataEntryDatas = [
  {
    userName: "Ahmed Abdullahi",
    email: "ahmed.abdullahi@example.com",
    contactNo: "701 234 1111",
    baseAddress: "23 Waziri Street, Gombe, Gombe State",
    state: "Gombe",
    city: "Gombe",
    addedOn: 1730466600000,
    status: "Active"
  },
  {
    userName: "Musa Ibrahim",
    email: "musa.ibrahim@example.com",
    contactNo: "702 345 2222",
    baseAddress: "5 Sule Lamido Crescent, Dutse, Jigawa State",
    state: "Jigawa",
    city: "Dutse",
    addedOn: 1730378400000,
    status: "In Active"
  },
  {
    userName: "Tolu Adeyemi",
    email: "tolu.adeyemi@example.com",
    contactNo: "703 456 3333",
    baseAddress: "12 Ikorodu Road, Ikeja, Lagos State",
    state: "Lagos",
    city: "Ikeja",
    addedOn: 1730290200000,
    status: "Pending"
  },
  {
    userName: "Halima Yusuf",
    email: "halima.yusuf@example.com",
    contactNo: "704 567 4444",
    baseAddress: "8 Wuse Market Road, Abuja, FCT",
    state: "FCT",
    city: "Abuja",
    addedOn: 1730202000000,
    status: "Active"
  },
  {
    userName: "Joseph Obinna",
    email: "joseph.obinna@example.com",
    contactNo: "705 678 5555",
    baseAddress: "45 Owerri Road, Owerri, Imo State",
    state: "Imo",
    city: "Owerri",
    addedOn: 1730113800000,
    status: "In Active"
  },
  {
    userName: "Maryam Sule",
    email: "maryam.sule@example.com",
    contactNo: "706 789 6666",
    baseAddress: "1 Abdullahi Road, Birnin Kebbi, Kebbi State",
    state: "Kebbi",
    city: "Birnin Kebbi",
    addedOn: 1730025600000,
    status: "Active"
  },
  {
    userName: "Peter Eze",
    email: "peter.eze@example.com",
    contactNo: "707 890 7777",
    baseAddress: "67 Nsukka Road, Nsukka, Enugu State",
    state: "Enugu",
    city: "Nsukka",
    addedOn: 1729937400000,
    status: "Pending"
  },
  {
    userName: "Fatima Danladi",
    email: "fatima.danladi@example.com",
    contactNo: "708 901 8888",
    baseAddress: "22 Jabi Close, Jabi, Abuja, FCT",
    state: "FCT",
    city: "Abuja",
    addedOn: 1729849200000,
    status: "Active"
  },
  {
    userName: "Chinelo Nduka",
    email: "chinelo.nduka@example.com",
    contactNo: "709 012 9999",
    baseAddress: "14 New Layout Road, Aba, Abia State",
    state: "Abia",
    city: "Aba",
    addedOn: 1729761000000,
    status: "In Active"
  },
  {
    userName: "Bola Oyetunde",
    email: "bola.oyetunde@example.com",
    contactNo: "710 123 0000",
    baseAddress: "9 Ring Road, Ibadan, Oyo State",
    state: "Oyo",
    city: "Ibadan",
    addedOn: 1729672800000,
    status: "Active"
  },
  {
    userName: "Aminu Jibril",
    email: "aminu.jibril@example.com",
    contactNo: "711 234 1112",
    baseAddress: "21 Kano Road, Zaria, Kaduna State",
    state: "Kaduna",
    city: "Zaria",
    addedOn: 1729584600000,
    status: "Pending"
  },
  {
    userName: "Uchenna Okoro",
    email: "uchenna.okoro@example.com",
    contactNo: "712 345 2223",
    baseAddress: "88 Asaba Road, Asaba, Delta State",
    state: "Delta",
    city: "Asaba",
    addedOn: 1729496400000,
    status: "Active"
  }
]

export const FieldAgentDataVerificationDatas = [
  {
    userName: "Adebayo Olu",
    email: "adebayo.olu@example.com",
    contactNo: "701 111 1234",
    baseAddress: "5 Alagomeji Street, Yaba, Lagos State",
    state: "Lagos",
    city: "Yaba",
    addedOn: 1730382000000,
    status: "Active"
  },
  {
    userName: "Zainab Musa",
    email: "zainab.musa@example.com",
    contactNo: "702 222 2345",
    baseAddress: "18 Stadium Road, Ilorin, Kwara State",
    state: "Kwara",
    city: "Ilorin",
    addedOn: 1730295600000,
    status: "In Active"
  },
  {
    userName: "Chukwuemeka Obi",
    email: "chukwuemeka.obi@example.com",
    contactNo: "703 333 3456",
    baseAddress: "25 Old Market Road, Onitsha, Anambra State",
    state: "Anambra",
    city: "Onitsha",
    addedOn: 1730209200000,
    status: "Pending"
  },
  {
    userName: "Fatima Ahmed",
    email: "fatima.ahmed@example.com",
    contactNo: "704 444 4567",
    baseAddress: "8 Tudun Wada Street, Jos, Plateau State",
    state: "Plateau",
    city: "Jos",
    addedOn: 1730122800000,
    status: "Active"
  },
  {
    userName: "Oluchi Nwosu",
    email: "oluchi.nwosu@example.com",
    contactNo: "705 555 5678",
    baseAddress: "2 Umuahia Road, Aba, Abia State",
    state: "Abia",
    city: "Aba",
    addedOn: 1730036400000,
    status: "In Active"
  },
  {
    userName: "Hassan Usman",
    email: "hassan.usman@example.com",
    contactNo: "706 666 6789",
    baseAddress: "10 Bida Road, Minna, Niger State",
    state: "Niger",
    city: "Minna",
    addedOn: 1729950000000,
    status: "Active"
  },
  {
    userName: "Amina Abdullahi",
    email: "amina.abdullahi@example.com",
    contactNo: "707 777 7890",
    baseAddress: "7 Ramat Crescent, Maiduguri, Borno State",
    state: "Borno",
    city: "Maiduguri",
    addedOn: 1729863600000,
    status: "Pending"
  },
  {
    userName: "Segun Adetola",
    email: "segun.adetola@example.com",
    contactNo: "708 888 8901",
    baseAddress: "32 Oluyole Street, Ibadan, Oyo State",
    state: "Oyo",
    city: "Ibadan",
    addedOn: 1729777200000,
    status: "Active"
  },
  {
    userName: "Maryam Sani",
    email: "maryam.sani@example.com",
    contactNo: "709 999 9012",
    baseAddress: "5 Emir's Palace Road, Kano City, Kano",
    state: "Kano",
    city: "Kano",
    addedOn: 1729690800000,
    status: "In Active"
  },
  {
    userName: "Paul Etim",
    email: "paul.etim@example.com",
    contactNo: "710 000 0123",
    baseAddress: "9 Calabar Road, Calabar, Cross River State",
    state: "Cross River",
    city: "Calabar",
    addedOn: 1729604400000,
    status: "Active"
  },
  {
    userName: "Bukola Adebayo",
    email: "bukola.adebayo@example.com",
    contactNo: "711 111 1234",
    baseAddress: "15 GRA Avenue, Lokoja, Kogi State",
    state: "Kogi",
    city: "Lokoja",
    addedOn: 1729518000000,
    status: "Pending"
  },
  {
    userName: "Ngozi Eze",
    email: "ngozi.eze@example.com",
    contactNo: "712 222 2345",
    baseAddress: "12 Independence Avenue, Awka, Anambra State",
    state: "Anambra",
    city: "Awka",
    addedOn: 172943160000,
    status: "Active"
  }
]

export const BaseAddressInfo = [
  {
    id: 1,
    label: "3 Diamond Hill Road, Calabar, Cross River State",
    value: "3 Diamond Hill Road, Calabar, Cross River State",
    state: "Cross River",
    city: "Calabar"
  },
  {
    id: 2,
    label: "Force Headquarters, Shehu Shagari Way, Central Business District, Abuja, FCT",
    value: "Force Headquarters, Shehu Shagari Way, Central Business District, Abuja, FCT",
    state: "FCT",
    city: "Abuja"
  },
  {
    id: 3,
    label: "1 Kam Salem House, Moloney Street, Onikan, Lagos State",
    value: "1 Kam Salem House, Moloney Street, Onikan, Lagos State",
    state: "Lagos",
    city: "Onikan"
  },
  {
    id: 4,
    label: "1 Federal Secretariat Road, Benin City, Edo State",
    value: "1 Federal Secretariat Road, Benin City, Edo State",
    state: "Edo",
    city: "Benin City"
  }
];